import { ThirdPartyCategories } from "src/modules/3rd-party-management/constants";

const getPredefinedCategoryValues = (thirdPartyType) => {
    return (ThirdPartyCategories[thirdPartyType] || []).map((category) => category.value);
};

const isPredefinedCategory = (subType, thirdPartyType) => {
    if (!subType) {
        return false;
    }

    return getPredefinedCategoryValues(thirdPartyType).includes(subType);
};

const resolveThirdPartyCategoryForForm = (subType, thirdPartyType, customSubType) => {
    if (!subType) {
        return {
            selectValue: '',
            otherText: ''
        };
    }

    if (subType === 'other') {
        return {
            selectValue: 'other',
            otherText: customSubType || ''
        };
    }

    if (isPredefinedCategory(subType, thirdPartyType)) {
        return {
            selectValue: subType,
            otherText: ''
        };
    }

    return {
        selectValue: 'other',
        otherText: subType
    };
};

const resolveThirdPartyCategoryForSubmit = (selectValue, otherText) => {
    if (selectValue === 'other') {
        return otherText;
    }

    return selectValue;
};

const getThirdPartyCategoryLabel = (subType, thirdPartyType, t, customSubType) => {
    if (!subType) {
        return '';
    }

    if (subType === 'other' && customSubType) {
        return customSubType;
    }

    const category = (ThirdPartyCategories[thirdPartyType] || []).find((tCat) => tCat.value === subType);

    if (category) {
        return t(category.label);
    }

    return subType;
};

export {
    resolveThirdPartyCategoryForForm,
    resolveThirdPartyCategoryForSubmit,
    getThirdPartyCategoryLabel
};
